<div *ngIf="isDataExist" class="justify-content-end m-t-10 m-b-20">
	<button class="w-20" mat-raised-button color="accent" (click)="showTotalUtilisationPerProvider()">
		<mat-icon class="font-medium">visibility</mat-icon>
		Utilisation Per Provider
	</button>
</div>

<ng-container *ngIf="isDataExist;
                  then showTransactionDataTable else emptyTransactionDataTable"></ng-container>

<ng-template #showTransactionDataTable>
  <form [formGroup]="formGroup">

    <table class="w-100" mat-table matSort [dataSource]="encounterCaseLinkDataSource"
           #MatSortTransactionStep="matSort">

			<ng-container [matColumnDef]="tableColumns.ICONS">
				<th *matHeaderCellDef mat-header-cell></th>
				<td *matCellDef="let row" mat-cell>
					<mat-icon class="table-icon font-medium" matTooltip="VIEW Details"
										(click)="viewClaimDetails($event, row?.encounterDTO.transactionId)">
						info
					</mat-icon>
				</td>
			</ng-container>

      <ng-container [matColumnDef]="tableColumns.TRANSACTION_ID">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Claim ID</th>
        <td *matCellDef="let row" mat-cell>{{row.encounterDTO?.transactionId}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.TYPE">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Type</th>
        <td *matCellDef="let row" mat-cell>{{row.encounterDTO?.type}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.PROVIDER">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Provider</th>
        <td *matCellDef="let row" mat-cell>{{row.encounterDTO?.provider.name}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.RECEIVED_DATE">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Date Received</th>
        <td *matCellDef="let row" mat-cell>{{row.encounterDTO?.receivedDate | date: dateFormat}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.START_DATE">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Encounter Date</th>
        <td *matCellDef="let row" mat-cell>{{row.encounterDTO?.startDate | date: dateFormat}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.ASSESSING_STATUS">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Assessing Status</th>
        <td *matCellDef="let row" mat-cell>{{row.encounterDTO?.assessingStatus}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.PAY_TO">
        <th *matHeaderCellDef mat-header-cell mat-sort-header class="w-5">Pay</th>
        <td *matCellDef="let row" mat-cell
            [matTooltip]="(row.encounterDTO?.type == ClaimType.CLAIM ? row.encounterDTO?.payTo : null)">
          {{(row.encounterDTO?.type == ClaimType.CLAIM ? ClmFunctions.getPayToAcronym(row.encounterDTO?.payTo) : null)}}
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.AMOUNT_CLAIMED">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Claimed Amount</th>
        <td *matCellDef="let row" mat-cell>{{row.encounterDTO?.amountClaimed | number: '.2'}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.AMOUNT_BENEFIT">
        <th class="w-25" *matHeaderCellDef mat-header-cell mat-sort-header>Benefit Amount</th>
        <td *matCellDef="let row" mat-cell>{{row.encounterDTO?.amountBenefit | number: '.2'}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="encounterCaseLinDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: encounterCaseLinDisplayedColumns;"></tr>
    </table>

    <mat-paginator #MatPaginatorTransactionStep="matPaginator"
                   [pageIndex]="paginatorControls.pageNumber"
                   [pageSize]="paginatorControls.pageSize"
                   [pageSizeOptions]="paginatorControls.pageSizeOptions">
    </mat-paginator>

    <ng-container [ngTemplateOutlet]="PrevAndNextButtons"></ng-container>
  </form>
</ng-template>

<ng-template #emptyTransactionDataTable>
  <div class="text-center">
    <label class="column-label claim-column-label">No transaction data</label>
  </div>
  <ng-container [ngTemplateOutlet]="PrevAndNextButtons"></ng-container>
</ng-template>

<ng-template #PrevAndNextButtons>
  <div class="button-container">
    <button mat-raised-button matStepperPrevious color="primary">Back</button>
    <button mat-raised-button matStepperNext color="primary">Next</button>
  </div>
</ng-template>
